export const phasesSorts = [
  {
    name: 'Creation date',
    value: 'CREATED_AT',
  },
  {
    name: 'Start date',
    value: 'startDate',
  },
  {
    name: 'End date',
    value: 'endDate',
  },
  {
    name: 'Name',
    value: 'name',
  },
];
